export var getters = {
    getPages: function (state) { return function (jobId) { return state.pages[jobId] || []; }; },
    getHeroImage: function (state, getters, rootState) { return function (landingPage) {
        if (landingPage.heroImage) {
            return landingPage.heroImage.fullUrl;
        }
        if (rootState.companySettings.branding && rootState.companySettings.branding.heroImage) {
            return rootState.companySettings.branding.heroImage.fullUrl;
        }
        return null;
    }; },
    getLoadingState: function (state) { return function (jobId) { return state.loading[jobId]; }; },
    getPublishedState: function (state) { return function (landingPageId, jobId) {
        var page = state.pages[jobId].find(function (page) { return page.id === landingPageId; });
        if (!page) {
            return false;
        }
        return page.isPublished;
    }; },
};
